<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :row-class-name="rowClassName"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="waybillDetailCode"
      show-header-overflow
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:orderso="{ row }">
        <div>
          <span>{{ row.orderSoNo ? row.orderSoNo : '--' }}</span>
        </div>
      </template>
      <template v-slot:orderStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'N'
              ? 'success'
              : row.orderStatus === 'Y'
              ? 'light'
              : 'warning'
          "
        >
          {{ row.orderStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            content="查看回单"
            placement="top"
          >
            <i
              class="el-icon-picture-outline tool-btn"
              @click="viewPodImage(row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="确认回单"
            v-allow="'actPodAudit'"
            placement="top"
          >
            <i
              class="el-icon-circle-check tool-btn"
              @click="commitStatus(row, 'Y')"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="拒绝回单"
            v-allow="'actPodAudit'"
            placement="top"
          >
            <i
              class="el-icon-circle-close tool-btn"
              @click="commitStatus(row, 'R')"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:orderNo="{ row }">
        <div>
          <el-link type="primary" @click="openOrderDetailPage(row.orderNo)">
            {{ row.orderNo }}
          </el-link>
        </div>
      </template>
    </vxe-grid>
    <div v-show="false" class="images" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in imageList"
        :src="$osscdn(item.imageUrl) || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  components: {},
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      previewDialogOptions: {
        viewVisible: false,
        code: '',
      },
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      selectList: [],
      fullScreenLoading: false,
      imageList: [],
      rowClassName: ({ row }) => {
        if (row.v_isAbnormal === '异常') {
          return 'bg-danger text-white'
        }
        return ''
      },
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 204
    },

    getTableCheckedData(isNotEmpty) {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (isNotEmpty) {
        if (data === null || data === [] || data.length === 0) {
          this.$message({
            message: '请选择您要操作的数据！',
            type: 'warning',
          })
          return
        }
      }
      return data
    },
    batchExport() {
      const data = this.getTableCheckedData(true)
      if (!data) return

      this.$refs.table.exportData({
        filename: '回单待审核单据' + Date.now(),
        type: 'csv',
        data: data,
        columnFilterMethod({ column }) {
          return !['col-opt', 'checkbox'].includes(column.property)
        },
      })
    },

    commitStatus(row, status) {
      let listCode = [row.dispatchOrderCode]
      let waybillDetailCodeList = [row.waybillDetailCode]
      let msg = '是否要对当前回单，进行【确认】操作？'
      if (status === 'R') {
        msg = '是否要对当前回单，进行【拒绝】操作？'
      }
      this.$confirm(msg, '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$emit('checkPod', listCode, status,waybillDetailCodeList)
      })
    },
    viewPodImage(row) {
      this.fullScreenLoading = true
      this.imageList = []
      let params = {
        linkBillType: 'C',
        dispatchOrderCode: row.dispatchOrderCode,
      }
      this.$api
        .carriageWaybillimgListApi(params)
        .then((res) => {
          this.fullScreenLoading = false
          this.imageList = res.body.data
          this.imageView()
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    imageView() {
      // 点击大图显示图片预览组件
      if (this.imageList.length > 0) {
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()
      }
    },
    openOrderDetailPage(no) {
      this.$router.push({
        name: 'carriage-order-detail-page',
        params: { no },
      })
    },
  },
}
</script>
